import { render } from "./datasets-utils.vue?vue&type=template&id=c0ec6c28"
import script from "./datasets-utils.vue?vue&type=script&lang=js"
export * from "./datasets-utils.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__